module.exports = __webpack_public_path__ + "static/media/longHill.18f77a48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/longHill.jpg
// module id = 954
// module chunks = 0